module.exports = __webpack_public_path__ + "img/New Project (5).6d2d3678.png";